
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-partners",
      function () {
        return require("private-next-pages/for-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-partners"])
      });
    }
  